import { faStar } from '@awesome.me/kit-eee5f32034/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from './Card';

type TestimonialCardProps = {
    id: string;
    content: string;
    author: string;
    stars?: number;
    className?: string;
    testId?: string;
};

const TestimonialCard = ({
    id,
    content,
    author,
    stars = 5,
    className = '',
}: TestimonialCardProps) => {
    const images = Array.from(
        { length: Math.min(5, Math.max(0, stars)) },
        (_, index) => (
            <FontAwesomeIcon
                key={`${id}-star-${index}`}
                icon={faStar}
                fontSize={22}
                className={'text-primary drop-shadow-sm'}
                aria-label='review star'
            />
        ),
    );

    return (
        <Card
            id={`${id}-testimonial`}
            className={`bg-gray-100 dark:bg-neutral-900 text-center flex flex-col ${className}`}
        >
            <div className='flex justify-center gap-2 pt-5'>{images}</div>
            <figure className='flex flex-col justify-between m-auto max-w-full grow prose'>
                <blockquote
                    className='p-0 border-0 [&>p]:text-base grow'
                    title='Testimonial Quote'
                >
                    <p>{content}</p>
                </blockquote>
                <figcaption
                    className='mt-auto font-medium text-bold text-secondary text-lg'
                    title='Testimonial Author'
                >
                    {author}
                </figcaption>
            </figure>
        </Card>
    );
};

export default TestimonialCard;
